import { Action, createReducer, on } from '@ngrx/store';
import { GenesysCloudNotificationState as State, initialState } from '../genesys-cloud-notifications.state';
import * as NotificationActions from '../actions/notification.actions';

export const reducer = createReducer(
  initialState(),
  on(NotificationActions.connectToNotificationChannel, (state, { isReconnect }): State => ({
    ...state,
    retryCount: !isReconnect ? 0 : state.retryCount + 1
  })),
  on(NotificationActions.connectToNotificationChannelSuccess, (state): State => ({
    ...state,
    retryCount: 0
  }))
);

export function genesysCloudNotificationsReducer(state: State, action: Action): State {
  return reducer(state, action);
}
